export const administrationPoliciesMessages = {
  en: {
    titleAdd: 'Add policy',
    titleEdit: 'Edit policy',
    titleCopy: 'Copy policy',
    titleDetail: 'Policy detail',
    addBtn: 'Add policy',
    actionColumnTitle: 'Action',
    scopeType: {
      apiScopes: 'API endpoints scope',
      attributeScopes: 'Attributes scope',
    },
    deleteConfirmDialog: {
      btnSecondaryConfirm: 'Cancel',
      btnConfirm: 'Delete',
      header: 'Policy will be removed',
      subHeader: 'Are you sure you want to remove the policy?',
    },
    deleteNotification: 'Policy deleted',
    form: {
      copy: '(copy)',
      scopeType: 'Scope type',
      fields: {
        name: 'Policy name',
        description: 'Description',
        selectEndpoints: 'Select endpoints for policy',
        treePicker: {
          availableTitle: 'Available endpoints',
          selectedTitle: 'Selected endpoints',
        },
        filter: 'Filter',
      },
      validations: {
        requiredPolicyName: 'Policy name is required',
        requiredNonEmptyAttribute:
          'At least one non empty filter value is required',
      },
      buttons: {
        save: 'Save',
        cancel: 'Cancel',
      },
    },
    request: {
      resourceConflict: 'Policy with same name already exists',
    },
  },
};
